var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.locationId)?_c('router-link',{staticClass:"btn btn-info",attrs:{"to":'/integrations/platform-menu-imports/' + _vm.locationId}},[_vm._v(_vm._s(_vm.$t('platformMenuImport.title')))]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc99d9fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Integrations/PlatformMenuImports/PlatformMenuImportLink.vue
// module id = V8Nv
// module chunks = 1